import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, model, Signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import {
  ButtonComponent,
  LoaderComponent,
  MbsPopupType,
  MbsType,
  ModalComponent,
  ModalFooterDirective,
  SharedPersistentStateEnum,
  StatusComponent,
  TableCellDirective,
  TableGridComponent,
  TableHeader
} from 'mbs-ui-kit';
import { noop } from 'rxjs';
import { headers, subHeaders } from './async-result-modal.constants';
import { AsyncModalContext } from './async-result-modal.type';

@UntilDestroy()
@Component({
  selector: 'mbs-async-results-modal',
  templateUrl: './async-results-modal.component.html',
  styleUrls: ['./async-results-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    NgbTooltipModule,
    LoaderComponent,
    StatusComponent,
    ButtonComponent,
    I18NextPipe,
    ModalComponent,
    TableGridComponent,
    TableCellDirective,
    ModalFooterDirective
  ]
})
export abstract class AsyncResultsModalComponent {
  public readonly customTitle = model<string>('');
  public readonly data = model<AsyncModalContext>(null);

  // headers for table in modal with error
  protected headers: TableHeader[] = headers;
  // subheaders for table in modal with error
  protected subHeaders: TableHeader[] = subHeaders;

  // Overridable!
  protected subTitle: Signal<string> = computed(() => `${this.data()?.resultList.length}/${this.data()?.total}`);

  protected readonly type = MbsType;
  protected readonly mbsPopupType = MbsPopupType;
  protected readonly sharedPersistentStateEnum = SharedPersistentStateEnum;

  extractMessage(child): string {
    const original = (child?.inProgress ? child?.data?.progressState : child?.message) || '';
    let result = original;

    if (original.includes('ErrorMessage')) {
      try {
        const JSONString = `{${original.split('{')[1].split('}')[0]}}`;

        result = JSON.parse(JSONString)?.ErrorMessage || original;
      } catch (e) {
        noop();
      }
    }

    return result;
  }
}
